import { gridManager } from './blocks-grid';
class IntranetManager {
    manageFeedcontainer;
    constructor() {
        this.manageFeedcontainer = $('.js-ManagedIntranetFeed')[0];
        // overlay manager removes elements from DOM on close. Store to be able to reopen
        const manageFeedButton = $('.js-ManageFeedButton', this.manageFeedcontainer);
        manageFeedButton.on('click', () => {
            this.openManageFeedOverlay();
        });
    }
    async openManageFeedOverlay() {
        // overlay manager removes elements from DOM on close. Store to be able to reopen.
        let overlay = $('.js-ManageFeedOverlay', this.manageFeedcontainer);
        if (overlay.length) {
            $(this.manageFeedcontainer).data('overlayStore', overlay);
        }
        else {
            overlay = $(this.manageFeedcontainer).data('overlayStore');
        }
        const { overlayManager } = await import('./overlay');
        await overlayManager.open(overlay);
        const { Wizard } = await import('./wizard');
        const wizard = new Wizard(overlay.get(0));
        wizard.onWizardSubmittedSuccess = () => {
            overlayManager.close(overlay);
            const gridId = $('.js-ManagedIntranetFeed').find('.js-Grid').data('grid-id');
            const grid = gridManager.get(gridId);
            if (!grid) {
                return console.error(`Cannot find grid with id ${gridId}`);
            }
            grid.refresh();
        };
    }
}
const intranetManager = new IntranetManager();
export { IntranetManager, intranetManager };
